





import Vue from 'vue'
export default Vue.extend({

})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GroupOrUser.vue